import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import xlsx from "xlsx";
import ClientService from './../../../clientmanagement/services/clientmanagement.service';
import TripServices from './../../../firstAndLastmilemanagement/services/firstAndLastmilemanagement.service';
import Treeselect from '@riophae/vue-treeselect';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Multiselect from 'vue-multiselect';
import Loader from '../../../shared/components/loader'
import Util from '../../../shared/util/util'
const aws = require('aws-sdk')

aws.config.update({
    secretAccessKey: 'AKIAYDGGCIIFBPPHHGN4',
    accessKeyId: 'DvFNvaDmNRe2BiYIvDsrYeoPoAoaz1QnuE9g2dbw',
})

const s3 = new aws.S3({
    region: 'ap-south-1',
})

export default {
    name: 'PickuprequestCSV',
    components: {
        VueElementLoading,
        Treeselect,
        Loader,
        Multiselect
    },
    data: function () {
        return {
            isLoading: false,
            filename: "",
            val: 0,
            progress: 0,
            client: null,
            clientid: '',
            businessaccountname: '',
            clientbusinessdetailid: '',
            clientbusinessaccountid: '',
            SKUData: [],
            SKUlist: [],
            ClientUOM: "",
            activecontract: "",
            totalRecords: 0,
            successRecords: 0,
            failedRecords: {},
            showresult: false,
            disabled: false,
            FailedResultModal: false,
            disableclientselection: false,
            compNameArr: [],
            uomArr: [],
            manifestMethods: [],
            boxtypelist: [],
            clientFileType: 3,
            filesource: "../static/Sample_PickupRequest_Data.xlsx",
            showuploadresult: false,
            uploadResultData: [],
            importResultData: [],
            showimportbutton: false,
            showimportresult: false,
            batchsizeforimport: 0,
            validrecordsforimport: 0,
            Clientlist: [],
            userName: "",
            fileid: 0,
            file: null,
            stepOne: false,
            stepTwo: false,
            stepThree: false,
            progressarr: ['stop', 'stop', 'stop', 'stop'],
            totaldata: 0,
            validateddata: 0,
            validdateddatalist: [],
            limit: 10,
            showprogress: false,
            isEditing: false,
            showSpinner: false,
            clientErr: false,
            disableimport: false,
            offset: 0,
            prquploaded:false,
            createPRQarr:[]
        }
    },
    beforeMount() {
        window.addEventListener("beforeunload", this.preventNavigation)
        this.$once("hook:beforeDestroy", () => {
          window.removeEventListener("beforeunload", this.this.preventNavigation);
        })
      },
    
      beforeRouteLeave(to, from, next) {
        if (this.isEditing) {
          if (!window.confirm("Leave without saving?")) {
            return;
          }
        }
        next();
      },
      async beforeDestroy() {
        this.isEditing= false;
    },
    computed: {

    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.userName = userdetail.email;
        this.getCompanyShortName();
        // this.progressBar()
    },
    methods: {
        preventNavigation(event) {
            if (!this.isEditing) return
            event.preventDefault()
            event.returnValue = ""
          },
        async getCompanyShortName() {
            try {
                let InputPayload = {}
                var CompanyShortList = [];
                let result = await ClientService.GetClientListByActiveContracts(InputPayload);
                CompanyShortList = result.data.data.rows;
                let tempArr = [];
                for (var i = 0; i < CompanyShortList.length; i++) {
                    tempArr.push({
                        'id': CompanyShortList[i].clientbusinessaccountid,
                        'label': CompanyShortList[i].clientshortname,
                        'ContractId': CompanyShortList[i].id,
                        'CompanyName': CompanyShortList[i].clientcompanyname,
                        'ClientId': CompanyShortList[i].clientid,
                        'ClientBusinessAccountId': CompanyShortList[i].clientbusinessaccountid,
                        'ClientBusinessDetailId': CompanyShortList[i].clientbusinessdetailid,
                    });
                }
                this.Clientlist = tempArr.filter((v, i, a) => a.findIndex(t => (t.id === v.id)) === i);
            } catch (err) {
                console.log(err);
            }
        },
        async uploadBookingData(e) {
            if (!/\.(xls|xlsx)$/.test(e.target.files[0].name.toLowerCase())) {
                this.isLoading = false;
                this.$refs.files.value=null;
                return this.$alert('The upload format is incorrect. Please download template for correct format', "", "error");
            }
            this.filename = e.target.files[0].name;
            this.showprogress = true;
            const files = e.target.files;
            this.file = e.target.files[0]

            this.isLoading = false;
            // var reader = new FileReader()
            // reader.readAsDataURL(e.target.files[0])
            // let binaryfile = ''
            // reader.onload = async () => {
            //     binaryfile = reader.result
            //     let result = await this.singleUpload(files[0], 'BookingSoftUpload', reader.result)
            //     this.isLoading = false;
            //     console.log("result => ", result)

            // };
            // console.log(binaryfile);
        },
        async uploadFile(file) {
            try {
                let formData = new FormData();
                formData.append('file', file);
                formData.append('clientid', this.clientid);
                formData.append('clientname', this.businessaccountname);
                formData.append('clientbusinessaccountid', this.clientbusinessaccountid);
                formData.append('lastmodifiedby', this.userName);
                let result = await TripServices.uploadCSVFile(formData);
                if (result.data.code == 200) {
                    this.fileid = result.data.data.fileid
                    this.totaldata = result.data.data.totaldata;
                    return true
                } else {
                    this.$alert(result.data.message, "", "error");
                    return false
                }
            } catch (err) {
                console.log(err);
            }
        },
        singleUpload(file, folder, binaryfile) {
            try {
                const key = folder + '/' + Date.now() + '-' + file.name.replace(/\s/g, '-')
                const params = {
                    Bucket: 'stage-b2bmarketplace',
                    Key: key,
                    Expires: 20,
                    ContentType: file.type,
                }
                const url = s3.getSignedUrl('putObject', params)
                console.log(url);
                return axios
                    .put(url, binaryfile, {
                        headers: {
                            'Content-Type': file.type,
                        },
                    })
                    .then(result => {
                        console.log(result);
                        const bucketUrl = decodeURIComponent(result.request.responseURL).split(
                            key
                        )[0]
                        result.key = key
                        result.fullPath = bucketUrl + key
                        return result
                    })
                    .catch(err => {
                        // TODO: error handling
                        console.log(err)
                    })
            } catch (error) {
                console.log("Error occured", error);
            }
        },
        async validate(fileid, norecord) {
            try {
                let input = {
                    fileid: fileid,
                    limit: norecord,
                    lastmodifiedby: this.userName,
                    offset: this.offset
                }
                let result = await TripServices.validatecsvfile(input)
                if (result.data.code == 200) {
                    this.validateddata = norecord + this.offset;
                    this.offset = this.offset + this.limit;
                    this.validdateddatalist.push(...result.data.data)
                    return result.data.data;
                } else {

                }
            } catch (err) {
                console.log(err);
            }
        },
        groupBy(array, property) {
            var hash = {};
            for (var i = 0; i < array.length; i++) {
                if (!hash[array[i][property]]) hash[array[i][property]] = [];
                hash[array[i][property]].push(array[i]);
            }
            return hash;
        },
        openUploadResultData(type) {
            this.showuploadresult = true;
            this.uploadResultData = null;
            this.showimportbutton = false;
            if (type == 'valid') {
                this.uploadResultData = this.successRecords;
                this.showimportresult = false;
                if (this.successRecords.length > 0 || this.importResultData.length != this.successRecords.length) {
                    this.showimportbutton = true;
                }
            } else if (type == 'invalid') {
                this.showimportresult = false;
                this.showimportbutton = false;
                this.uploadResultData = this.failedRecords;
            }
        },
        async importValidRecords() {
            try{
                this.$set(this.progressarr, 2 , 'start')
                this.showSpinner=true;
                this.disableimport=true;
                let input = {
                    fileid: this.fileid
                }
                let result = await TripServices.PickupRequestSaveCSVData(input);
                if (result.data.code == 200) {
                    this.$set(this.progressarr, 2 , 'complete')
                    this.$set(this.progressarr, 3 , 'complete')
                    this.isEditing = false;
                    this.disableimport = true;
                    this.showSpinner=false;
                    this.$alert("You have successfully created Pickup Request, Please find Req. ID in below table.", "", "success");
                    this.showPRQDetails(result.data.data)
                } else {
                    this.$alert(result.data.message, "", "error");
                }
            } catch ( err){
                console.log(err);
            }
        },
        downloadFile() {
            try {
                let downloadArr = [];
                if (this.uploadResultData) {
                    downloadArr = this.uploadResultData.map((el) => {
                        return {
                            "Pickup Pincode": el.pickuppincode,
                            "Destination Pincode": el.destinationpincode,
                            "Route Mode": el.routemode,
                            "Pickup Location": el.pickuplocation,
                            "Pickup Address": el.pickupaddress1,
                            "Contact Name": el.contactname,
                            "Contact Number": el.mobile,
                            "Alternate Contact Number": el.alternatemobile,
                            "Email": el.pickupemail,
                            "Number of Boxes": el.numberofmps,
                            "Physical Weight(KG)": el.totalwt,
                            "Requested Pickup date MM/DD/YYYY": el.requestedpickupdate ? Util.displayDateOnlyFormat(el.requestedpickupdate): "",
                            "GST No": el.pickupgst,
                            "Pickup Instruction": el.pickupinstruction,
                            "Message": el.comment,
                        }
                    });
                    var filename='InvalidRecords.xlsx';
                    var ws = xlsx.utils.json_to_sheet(downloadArr);
                    var wb = xlsx.utils.book_new();
                    xlsx.utils.book_append_sheet(wb, ws, "Sheet1");
                    xlsx.writeFile(wb,filename);
                } else {
                    const data = xlsx.utils.json_to_sheet(downloadArr);
                    const wb = xlsx.utils.book_new();
                    xlsx.utils.book_append_sheet(wb, data, 'data')
                    xlsx.writeFile(wb, 'InvalidRecords.xlsx');
                }
            } catch (err) {
                console.log(err);
            }
        },
        async selectClient(data) {
            this.resetform();
            if (data) {
                this.activecontract = data.ContractId;
                this.clientid = data.ClientId;
                this.businessaccountname = data.CompanyName;
                this.clientbusinessdetailid = data.ClientBusinessDetailId;
                this.clientbusinessaccountid = data.ClientBusinessAccountId;
                this.disableclientselection = true;
            }
        },
        resetform() {
            this.filename = "";
            this.val = 0;
            this.progress = 0;
            this.client = null;
            this.clientid = '';
            this.businessaccountname = '';
            this.clientbusinessdetailid = '';
            this.clientbusinessaccountid = '';
            this.SKUData = [];
            this.SKUlist = [];
            this.ClientUOM = "";
            this.activecontract = "";
            this.totalRecords = 0;
            this.successRecords = 0;
            this.failedRecords = {};
            this.showresult = false;
            this.disabled = false;
            this.FailedResultModal = false;
            this.disableclientselection = false;
            this.compNameArr = [];
            this.uomArr = [];
            this.manifestMethods = [];
            this.boxtypelist = [];
            this.clientFileType = 3;
            this.showuploadresult = false;
            this.uploadResultData = [];
            this.importResultData = [];
            this.showimportbutton = false;
            this.showimportresult = false;
            this.batchsizeforimport = 0;
            this.validrecordsforimport = 0;
            this.fileid = 0;
            this.file = null;
            this.stepOne = false;
            this.stepTwo = false;
            this.stepThree = false;
            this.progressarr = ['stop', 'stop', 'stop', 'stop'];
            this.totaldata = 0;
            this.validateddata = 0;
            this.validdateddatalist = [];
            this.limit = 10;
            this.showprogress = false;
            this.offset = 0
            this.$validator.reset();
            this.isEditing = false;
            this.showSpinner = false;
            this.$refs.files.value=null;
            this.clientErr = false;
        },
        submitFile() {
            try {
                this.$validator.validateAll("uploadform").then((result) => {
                    if (!result) {
                    } else if (this.clientid == '') {
                        this.clientErr = true;
                    } else {
                        this.startUpload();
                    }
                }).catch(() => {
                    console.log('errors exist');
                    return false;
                });
                
            } catch (error) {
                console.log(error);
            }
        },
        async startUpload() {
            try {
                this.disabled = true;
                this.$set(this.progressarr, 0 , 'start')
                this.isEditing= true;
                this.showSpinner= true;
                this.stepOne = await this.uploadFile(this.file)
                // this.stepOne = true
                // this.totaldata = 15
                // this.fileid = 15
                if (this.stepOne) {
                    let result;
                    this.$set(this.progressarr, 0 , 'complete')
                    this.$set(this.progressarr, 1 , 'start')
                    while (this.validateddata < this.totaldata) {
                        let norecord = this.limit
                        if (this.limit + this.offset > this.totaldata) {
                            norecord = this.totaldata - this.offset
                        }
                        result = await this.validate(this.fileid, norecord);
                    }
                    let tempData = this.groupBy(this.validdateddatalist, "status");
                    this.totalRecords = this.totaldata;
                    if (tempData[1]) {
                        this.successRecords = tempData[1];
                        this.validrecordsforimport = tempData[1].length;

                    }
                    if (tempData[0]) {
                        this.failedRecords = tempData[0];
                    }
                    this.showresult = true;
                    this.stepTwo = true;
                    this.$set(this.progressarr, 1 , 'complete')
                    this.showSpinner = false
                }
            } catch (error) {
                console.log(error);
            }
        },
        async showPRQDetails(data) {
            try {
                this.createPRQarr = data.map((el) => {
                    return {
                        "id": el.id,
                        "clientname": el.clientname,
                        "pickuppincode": el.pickuppincode,
                        "destinationpincode": el.destinationpincode,
                        "pickupaddress": el.pickupaddress,
                        "numberofmps": el.numberofmps,
                        "totalwt": el.totalwt,
                        "requestedpickupdate": el.requestedpickupdate ? Util.displayDateOnlyFormat(el.requestedpickupdate): "",
                        "created": el.status==1? 'Yes':'No',
                        "pickupinstruction": el.pickupinstruction
                    }
                });
                this.prquploaded=true;
            } catch (error) {
                console.log(error)
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/pickuprequestcsv/pickuprequestcsv.component.js